/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getKpiDashboardApi } from "services/dashboard/kpiDashboard";
/* Project Import will be here */

export const types = {
    KPI_DASHBOARD_REQUEST: "kpiDashboard/kpiDashboardRequest",
    KPI_DASHBOARD_SUCCESS: "kpiDashboard/kpiDashboardSuccess",
    KPI_DASHBOARD_FAILURE: "kpiDashboard/kpiDashboardFailure"
};

let initialState = {
    isLoading: false,
    data: [],
    error: null
};

export const kpiDashboard = (state = initialState, action) => {
    switch (action.type) {
        case types.KPI_DASHBOARD_REQUEST:
            return { ...state, isLoading: true };
        case types.KPI_DASHBOARD_SUCCESS:
            return { isLoading: false, ...action.payload, error: null };
        case types.KPI_DASHBOARD_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error };
        default:
            return state;
    }
};

export const getKpiDashboard = () => {
    return async dispatch => {
        dispatch({ type: types.KPI_DASHBOARD_REQUEST });
        try {
            const response = await getKpiDashboardApi();
            dispatch({
                type: types.KPI_DASHBOARD_SUCCESS,
                payload: {
                    data: response.data.Data
                }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.KPI_DASHBOARD_FAILURE,
                payload: { error: message }
            });
        }
    };
};